import { HotelSearchedRoomRate, HotelSearchedRoom } from '@hotels/hotel-results/entities/hotel-searched';

export function isGroupedViewByHotelDetail(
  rooms: HotelSearchedRoom[], rates: HotelSearchedRoomRate[]
): boolean {
  return (rates?.length === 1 && rates?.[0]?.RoomIds?.length > 1) || rates?.length === rooms?.length;
}
